import React from 'react';
import { connect } from 'react-redux';
import { updateStats } from '../actions/stats';
import { Form, Segment, Input } from 'semantic-ui-react';
import NumberFormat from 'react-number-format';

class InputForm extends React.Component {
  state = { pageViews: 5000000, uniqueVisitors: 800000, impressions: 2700000 }

  // componentWillReceiveProps (nextProps) {
  //   const { pageViews, uniqueVisitors, impressions } = nextProps;
  //   const avgPageViews = (pageViews / uniqueVisitors).toFixed(2);
  //   console.log ("avg: ", avgPageViews);
  //   const percentOfViewsWithAd = (impressions / pageViews).toFixed(2);
  // }

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value }, () => this.test());
    e.preventDefault();
  }

  test = () => {
    let { pageViews, impressions, uniqueVisitors } = this.state;
    let { dispatch, id } = this.props;
    let stats = { pageViews: parseInt(pageViews), impressions: parseInt(impressions), uniqueVisitors: parseInt(uniqueVisitors) };
    dispatch({type: 'UPDATE_STATS', stats: stats})
  }

  render() {
    return (
      <div>
        <Segment basic>
          {/* vertical spacer */}
        </Segment>
        <h2>Site and Advertiser Data</h2>
        <Form onSubmit={this.handleSubmit} size='big'>
          <Form.Group widths='equal'>
            <Form.Field>
              <label>Monthly Page Views</label>
              <NumberFormat
                value={this.state.pageViews}
                placeholder={this.state.pageViews}
                thousandSeparator={true}
                name="pageViews"
                isNumericString={true}
                onValueChange={(values) => {
                  const {formattedValue, value} = values;
                  // console.log("formattedValue: ", formattedValue);
                  // console.log("value: ", value);
                  this.setState({ pageViews: value }, () => this.test());
              }}/>
            </Form.Field>
            <Form.Field>
              <label>Monthly Unique Visitors</label>
              <NumberFormat
                value={this.state.uniqueVisitors}
                placeholder={this.state.uniqueVisitors}
                thousandSeparator={true}
                name="uniqueVisitors"
                isNumericString={true}
                onValueChange={(values) => {
                  const {formattedValue, value} = values;
                  // console.log("formattedValue: ", formattedValue);
                  // console.log("value: ", value);
                  this.setState({ uniqueVisitors: value }, () => this.test());
              }}/>
            </Form.Field>
            <Form.Field>
              <label>Impressions Purchased</label>
              <NumberFormat
                value={this.state.impressions}
                placeholder={this.state.impressions}
                thousandSeparator={true}
                name="impressions"
                isNumericString={true}
                onValueChange={(values) => {
                  const {formattedValue, value} = values;
                  this.setState({ impressions: value }, () => this.test());
              }}/>
            </Form.Field>
          </Form.Group>
        </Form>
        <Segment inverted color='teal' tertiary>
          <Form>
            <Form.Group widths='equal'>
              <Form.Field>
                <label>Average Page Views Per Unique Visitor</label>
                <Input
                  style={centeredInput}
                  readOnly
                  value={(this.state.pageViews / this.state.uniqueVisitors).toFixed(2)}
                />
              </Form.Field>
              <Form.Field>
                <label>Percentage of Page Views Displaying Our Ad</label>
                <Input
                  readOnly
                  value={((this.state.impressions / this.state.pageViews) * 100).toFixed(1) + "%"}
                />
              </Form.Field>
            </Form.Group>
          </Form>
        </Segment>
      </div>
    )
  }
}

const centeredInput = {
  textAlign: 'center',
};

const mapStateToProps = (state) => {
  return {
    impressions: state.stats.impressions,
    pageViews: state.stats.pageViews,
    uniqueVisitors: state.stats.uniqueVisitors,
  }
}

export default connect(mapStateToProps)(InputForm);



// WEBPACK FOOTER //
// ./src/components/Form.js